import { useEffect, useState } from 'react';

const navLinks = [
  { label: '热门推荐', href: '#hot' },
  { label: '分类浏览', href: '#categories' },
  { label: '人气排行', href: '#ranking' },
  { label: '最新更新', href: '#latest' },
  { label: '常见问题', href: '#faq' },
  { label: '关于我们', href: '#about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'bg-background-50/95 shadow-sm backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <nav
        className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6"
        aria-label="主导航"
      >
        <a href="#home" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg" />
          </span>
          <span className="font-display text-xl font-bold text-foreground-900">
            嘿休漫画
            <span className="text-primary-600">网址</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </div>

        <button
          type="button"
          aria-label={open ? '关闭菜单' : '打开菜单'}
          onClick={() => setOpen((v) => !v)}
          className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-900 transition-colors hover:bg-background-200 md:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="flex flex-col px-4 py-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}